import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M10 8h8v2h-8v8H8v-8H0V8h8V0h2z" />
  </svg>
);

export default SvgComponent;
